import { render, staticRenderFns } from "./asn-quota-config-menu.vue?vue&type=template&id=31fd6e80&scoped=true"
import script from "./asn-quota-config-menu.vue?vue&type=script&lang=ts"
export * from "./asn-quota-config-menu.vue?vue&type=script&lang=ts"
import style0 from "./asn-quota-config-menu.vue?vue&type=style&index=0&id=31fd6e80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fd6e80",
  null
  
)

export default component.exports